import React from 'react';
import gettext from 'js-utils/gettext';
import IconButton from '../iconButton/IconButton';
import CopyChunkySvg from '../iconography/icons/CopyChunky';
export var renderIconButton = function renderIconButton() {
  return React.createElement(IconButton, {
    iconType: React.createElement(CopyChunkySvg, null),
    title: gettext('Copy')
  });
};